import { render, staticRenderFns } from "./ReportHistory.vue?vue&type=template&id=a5db336e&scoped=true&"
import script from "./ReportHistory.vue?vue&type=script&lang=js&"
export * from "./ReportHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReportHistory.vue?vue&type=style&index=0&id=a5db336e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5db336e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
